var map = {
	"./video1.png": 3815,
	"./video10.png": 7044,
	"./video11.png": 9467,
	"./video12.png": 8843,
	"./video13.png": 4037,
	"./video14.png": 1064,
	"./video15.png": 9913,
	"./video2.png": 1950,
	"./video3.png": 8241,
	"./video4.png": 4048,
	"./video5.png": 1797,
	"./video6.png": 5664,
	"./video7.png": 7819,
	"./video8.png": 6677,
	"./video9.png": 4855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2487;